// src/api/ITapi.js
const API_BASE =
  import.meta.env.VITE_API_BASE_URL ||
  import.meta.env.VITE_API_BASE ||
  "/api";

function tokenHeader() {
  const t = localStorage.getItem("access_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function handle(res) {
  if (!res.ok) throw new Error(await res.text());
  const ct = res.headers.get("content-type") || "";
  if (ct.includes("application/json")) return res.json();
  return res.text();
}

// --------------------
// Current user
// --------------------
export async function itMe() {
  const res = await fetch(`${API_BASE}/it/me`, {
    headers: { ...tokenHeader() },
  });
  return handle(res);
}

// --------------------
// Requests
// --------------------
export async function createITRequest(payload) {
  const res = await fetch(`${API_BASE}/it/requests`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...tokenHeader() },
    body: JSON.stringify(payload),
  });
  return handle(res);
}

export async function listMyITRequests() {
  const res = await fetch(`${API_BASE}/it/requests/my`, {
    headers: { ...tokenHeader() },
  });
  return handle(res);
}

export async function listPendingApprovals() {
  const res = await fetch(`${API_BASE}/it/requests/pending`, {
    headers: { ...tokenHeader() },
  });
  return handle(res);
}

export async function adminListITRequests({
  status,
  request_type,
  q,
  limit = 50,
  offset = 0,
} = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (request_type) params.set("request_type", request_type);
  if (q) params.set("q", q);
  params.set("limit", String(limit));
  params.set("offset", String(offset));

  const res = await fetch(`${API_BASE}/it/requests?${params.toString()}`, {
    headers: { ...tokenHeader() },
  });
  return handle(res);
}

export async function getITRequest(requestId) {
  const res = await fetch(`${API_BASE}/it/requests/${requestId}`, {
    headers: { ...tokenHeader() },
  });
  return handle(res);
}

export async function decideITRequest(requestId, decision, comment = null) {
  const res = await fetch(`${API_BASE}/it/requests/${requestId}/decision`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...tokenHeader() },
    body: JSON.stringify({ decision, comment }),
  });
  return handle(res);
}

export async function addITComment(requestId, comment) {
  const url = `${API_BASE}/it/requests/${requestId}/comment?comment=${encodeURIComponent(
    comment
  )}`;
  const res = await fetch(url, {
    method: "POST",
    headers: { ...tokenHeader() },
  });
  return handle(res);
}

// --------------------
// Attachments
// --------------------
export async function uploadITAttachment(requestId, file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch(`${API_BASE}/it/requests/${requestId}/attachments`, {
    method: "POST",
    headers: { ...tokenHeader() },
    body: form,
  });
  return handle(res);
}

export async function downloadITAttachment(attachmentId, filename = "attachment") {
  const res = await fetch(`${API_BASE}/it/attachments/${attachmentId}/download`, {
    headers: { ...tokenHeader() },
  });
  if (!res.ok) throw new Error(await res.text());

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
}

// --------------------
// Chatbot
// --------------------
export async function itChat(message) {
  const res = await fetch(`${API_BASE}/it/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...tokenHeader() },
    body: JSON.stringify({ message }),
  });
  return handle(res);
}
